module.exports = __webpack_public_path__ + "img/27n.e07f9a9c.png";